import { getFlowConfig } from '../flow-initial/getFlowConfig';
export const hasManagementLevelEnabled = () => {
  return getFlowConfig().shouldUseManagementLevel();
};